<template>
    <div class="cz3__toolbar"
        :class="{
            'cz3__toolbar--important': important,
            'cz3__toolbar--justify': justify,
            'cz3__toolbar--no-scroll': noScroll,
            'cz3__toolbar--no-margins': noMargins,
        }"
    >
        <slot/>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__toolbar {
            flex: 1 0 auto;

            // Unmargin it on small screens.
            margin-left: -16px;
            margin-right: -16px;

            padding-top: 4px;
            padding-left: 16px;
            padding-right: 16px;

            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: flex-start;

            gap: 16px;

            &.cz3__toolbar--no-scroll {
                overflow: visible;
            }

            &.cz3__toolbar--justify {
                justify-content: center;

                gap: 24px;
            }

            &.cz3__toolbar--important {
                @include respond-above(sm) {
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;

                    gap: 16px;
                }
            }

            overflow: auto;
            -webkit-overflow-scrolling: touch;

            > *:first-child {
                margin-left: auto;

                @include respond-above(sm) {
                    margin-left: 0;
                }
            }

            > *:last-child {
                margin-right: auto;

                @include respond-above(sm) {
                    margin-right: 0;
                }
            }

            &.cz3__toolbar--no-margins {
                > *:first-child {
                    margin-left: 0;
                }

                > *:last-child {
                    margin-right: 0;
                }
            }

            @include respond-above(sm) {
                flex-wrap: wrap;
                align-content: flex-start;
                padding-bottom: 4px;

                gap: 14px;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            justify: Boolean,
            noScroll: Boolean,
            important: Boolean,
            noMargins: Boolean,
        },
    };
</script>
